import type { QuestionSetModule } from '@/lib/questionSetExtractionApi';

export const DEFAULT_CONTEXTS_PER_SECTION = 20;
export const MIN_CONTEXTS_PER_SECTION = 1;
export const MAX_CONTEXTS_PER_SECTION = 100;

export const QUESTION_SET_MODULES: ReadonlyArray<{
  value: QuestionSetModule;
  label: string;
}> = [
  { value: 'reading', label: 'Reading' },
  { value: 'listening', label: 'Listening' },
  { value: 'writing', label: 'Writing' },
  { value: 'speaking', label: 'Speaking' },
];

export function isValidContextsPerSection(value: number): boolean {
  return (
    Number.isInteger(value) &&
    value >= MIN_CONTEXTS_PER_SECTION &&
    value <= MAX_CONTEXTS_PER_SECTION
  );
}
